import React from 'react'
import classNames from 'classnames'
import get from 'lodash/get'

import Markdown from '@components/markdown'
import MaterialSetTypeBackground from '@backgrounds/material_set_type_background'
import MaterialSetTypeDesktopBackground from '@backgrounds/material_set_type_desktop_background'
import styles from '@components/blocks/components/material_category.module.scss'

const MaterialCategory = ({
  type,
  displayText,
  description,
  materials,
  color,
  contentGuidelinesAgreement,
}) => {
  const headerColorClass = styles[`material_category__header--${color}`]
  const categoryColumns = Math.min(Math.ceil(materials.length / 4), 3)

  return (
    <div className={styles.material_category}>
      <div className={classNames(styles.material_category__header, headerColorClass)}>
        <div className={styles.material_category__type_background}>
          <MaterialSetTypeBackground />
        </div>
        <div className={styles.material_category__type_desktop_background}>
          <MaterialSetTypeDesktopBackground />
        </div>
        <div className={styles.material_category__type}>{type}</div>
        <div className={styles.material_category__name}>{displayText}</div>
        <div className={styles.material_category__materials}>
          <ul
            className={classNames(
              styles.material_category__download_list,
              styles[`material_category__download_list--columns_${categoryColumns}`]
            )}
          >
            {materials.map(material => (
              <li key={material.id}>
                <Material fields={material.fields} categoryDisplayText={displayText} />
              </li>
            ))}
          </ul>
        </div>
        <Markdown className={styles.material_category__agreement}>
          {contentGuidelinesAgreement}
        </Markdown>
      </div>
      <div className={styles.material_category__content}>
        <Markdown className={styles.material_category__description}>{description}</Markdown>
      </div>
    </div>
  )
}

const Material = ({ fields: { displayText, file }, categoryDisplayText }) => {
  const fileUrl = get(file, 'fields.file.url')

  return (
    <a
      className={styles.material_category__download}
      href={fileUrl}
      target="_blank"
      rel="noopener noreferrer"
    >
      {displayText}
    </a>
  )
}

export default MaterialCategory
